import LocaleReceiver from './LocaleReceiver';
export default LocaleReceiver;
//# sourceMappingURL=index.js.map
